export default __webpack_public_path__ + "static/media/6428f1f03cce3f76b1132fdde3338e9b.jpg";